import { Heading, Paragraph, Popover } from '@digdir/designsystemet-react';
import { useTranslation } from 'react-i18next';

export const InfoPopover = () => {
  const { t } = useTranslation();
  return (
    <Popover.TriggerContext>
      <Paragraph>
        <Popover.Trigger inline>{t('register.solar.form.popover.label')}</Popover.Trigger>
      </Paragraph>
      <Popover>
        <Heading level={5} data-size="2xs">
          {t('register.solar.form.popover.azimuth.header')}
        </Heading>
        <Paragraph>{t('register.solar.form.popover.azimuth.info')}</Paragraph>
        <Heading level={5} data-size="2xs">
          {t('register.solar.form.popover.tilt.header')}
        </Heading>
        <Paragraph>{t('register.solar.form.popover.tilt.info')}</Paragraph>
      </Popover>
    </Popover.TriggerContext>
  );
};
